import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import AnalysisCard from './AnalysisCard' // Adjust the import path as necessary
import fetchData from '../../utils/fetchData'
import { CircularProgress } from '@mui/material'
const AnalysisSection = ({ selectedLob, setSecuredScore, setAppSummary }) => {
  const selectedApplicationId = useSelector(
    state => state.intakeData.selectedAppId
  )

  const [selectedApplicationData, setSelectedApplicationData] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    fetchData(
      `https://insureai-intake-dev-1074099157700.us-central1.run.app/insureai/ml/intake/applications/v2/application_appetite?application_id=${selectedApplicationId}`,
      'GET'
    )
      .then(data => {
        setSelectedApplicationData(data)
        setLoading(false)
      })
      .catch(error => {
        console.error('Error fetching appetite data:', error)
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    calCulateTotalScore(selectedApplicationData)
    setAppSummary(selectedApplicationData?.[selectedLob]?.Summary?.['Summary'])
  }, [selectedApplicationData])

  const calCulateTotalScore = data => {
    const lobData = data?.[selectedLob]?.['Summary'] || {}

    setSecuredScore(lobData.score)
  }

  const cardTypes = Object.keys(
    selectedApplicationData?.[selectedLob] || {
      'Required Information': {},
      'Exposure and Controls': {},
      'Account Analysis': {},
      'Do Not Write': {},
      'Risk Classification': {},
      Summary: {}
    }
  )

  return (
    <>
      {selectedLob && (
        <section className='flex flex-col items-center self-stretch px-5 mt-0 w-full py-5 max-md:px-5 max-md:py-24 max-md:mt-0 max-md:max-w-full'>
          {loading ? (
            <div className='flex justify-center items-center w-full h-full'>
              <CircularProgress color='warning' />
            </div>
          ) : (
            <>
              <div className='grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 appetite-stages'>
                {cardTypes.map(
                  type =>
                    type !== 'Summary' && (
                      <AnalysisCard
                        key={type}
                        cardData={
                          selectedApplicationData?.[selectedLob]?.[type]
                        }
                        cardType={type}
                        selectedLob={selectedLob}
                      />
                    )
                )}
              </div>
              <div className='flex mt-2 space-x-4'>
                <button
                  value='Approve'
                  className='bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600'
                >
                  Approve
                </button>
                <button
                  value='Reject'
                  className='bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-500'
                >
                  Decline
                </button>
                <button
                  value='Reject'
                  className='bg-black text-white px-4 py-2 rounded hover:bg-black-600'
                >
                  Escalate
                </button>
              </div>
            </>
          )}
        </section>
      )}
    </>
  )
}

export default AnalysisSection
